export default {
      id: "menu-grid-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#menu-grid",
      toString: function () {
        return this.url;
      }
    }